import {State, Module} from 'app/decorators';
import BaseRoute from 'app/routing';
import mainTpl from './templates/main.html';
import plantTpl from './templates/plant.html';
import {InventoryDashboardMainCtrl, InventoryDashboardPlantCtrl} from './ctrls.js';

@Module({
    name: 'app.inventoryDashboard.routing',
    modules: [
        BaseRoute,
    ],
})
@State({
    name: 'r.in.top.inventoryDashboard',
    url: '/inventory',
    template: mainTpl,
    controller: InventoryDashboardMainCtrl,
    ncyBreadcrumb: {
        label: 'Inventory',
        parent: 'r.in.top',
    },
    data: {
        permissions: {
            only: [
                'main.view_productinventory',
            ],
        },
    },
})
@State({
    name: 'r.in.top.inventoryDashboard.plant',
    url: '/{companyId:int}',
    controller: InventoryDashboardPlantCtrl,
    template: plantTpl,
    ncyBreadcrumb: {
        skip: true,
    },
    data: {
        permissions: {
            only: [
                'main.view_productinventory',
            ],
        },
    },
})
export default class States {}



// WEBPACK FOOTER //
// ./src/app/dashboard/inventory/routing.js